// Os menus ficam no body. A captura acontece antes dos stopPropagation do
// painel e dos cards; wheel também cobre o zoom do canvas (sem scroll nativo).
const registrations = new WeakMap();
const internalRegistrations = new WeakMap();

export function stopReteMultiselectOverlayClick(select) {
  if (internalRegistrations.has(select)) return;
  const overlay = select.$refs.overlay;
  if (!overlay) return;
  const stopClick = (event) => event.stopPropagation();
  const closeButton = overlay.querySelector(".p-multiselect-close");
  const closeFromButton = (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    select.hide();
    cleanup();
  };
  const closeOutside = (event) => {
    if (
      overlay.contains(event.target) ||
      select.$refs.container?.contains(event.target)
    )
      return;
    if (select.overlayVisible) select.hide();
    cleanup();
  };
  const cleanup = () => {
    overlay.removeEventListener("click", stopClick);
    closeButton?.removeEventListener("click", closeFromButton, true);
    document.removeEventListener("pointerdown", closeOutside, true);
    document.removeEventListener("click", closeOutside, true);
    select.$off("hide", cleanup);
    select.$off("hook:beforeDestroy", cleanup);
    internalRegistrations.delete(select);
  };
  overlay.addEventListener("click", stopClick);
  // O botão está dentro do contêiner que alterna o menu. Feche aqui para
  // impedir que o mesmo clique execute também a abertura.
  closeButton?.addEventListener("click", closeFromButton, true);
  document.addEventListener("pointerdown", closeOutside, true);
  document.addEventListener("click", closeOutside, true);
  internalRegistrations.set(select, cleanup);
  select.$once("hide", cleanup);
  select.$once("hook:beforeDestroy", cleanup);
}

export function registerReteSelectDismissal(select) {
  if (!select.overlayVisible || registrations.has(select)) return;

  const events = ["pointerdown", "click", "wheel", "scroll"];
  const options = { capture: true, passive: true };
  const cleanup = () => {
    events.forEach((type) =>
      document.removeEventListener(type, dismiss, options)
    );
    select.$off("hide", cleanup);
    select.$off("hook:beforeDestroy", cleanup);
    registrations.delete(select);
  };
  const dismiss = (event) => {
    const overlay = select.$refs.overlay;
    if (overlay?.contains(event.target)) return;
    if (
      ["pointerdown", "click"].includes(event.type) &&
      select.$refs.container?.contains(event.target)
    )
      return;
    if (select.overlayVisible) select.hide();
    cleanup();
  };

  registrations.set(select, cleanup);
  events.forEach((type) => document.addEventListener(type, dismiss, options));
  select.$once("hide", cleanup);
  select.$once("hook:beforeDestroy", cleanup);
}
